import { Text } from 'common-components'
import * as Styled from './styled'
import StarIcon from 'assets/svgr-icons/Star.svg'
import { memo } from 'react'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { IImageStyle } from '../types'

interface IAiImageStylesTogglerProps {
  isOpen: boolean
  style: IImageStyle
  disabled?: boolean
  label?: T
  setButtonRef: (ref: HTMLDivElement | null) => void
}

const AiImageStylesToggler: React.FC<IAiImageStylesTogglerProps> = ({
  isOpen,
  style,
  disabled,
  setButtonRef,
  label = T.SELECT_LABEL
}) => {
  const { thumbnailUrl, name } = style
  const title = name || translate(label)

  return (
    <Styled.ImageStylesButton
      $isToggled={isOpen}
      $disabled={disabled}
      ref={setButtonRef}
    >
      <Styled.ContentWrapper>
        {thumbnailUrl ? (
          <Styled.SelectedStyleImg>
            <Styled.StyleImage src={thumbnailUrl} />
          </Styled.SelectedStyleImg>
        ) : (
          <StarIcon />
        )}
        <Text type="h2" color="secondarySemiDark">
          {title}
        </Text>
      </Styled.ContentWrapper>
      <Styled.Arrow />
    </Styled.ImageStylesButton>
  )
}

export default memo(AiImageStylesToggler)
